import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import Select from 'react-select';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';
import Loader from '../../../Loader/Loader';
import uniqid from 'uniqid';
import Swal from 'sweetalert2'
import Hosts from '../../../../Hosts';
import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	translate,
} from '../../../../Utils';

import { language } from './Language';

import Intranet_Competicoes from '../Competicoes/Init'

const TIPO_JOGO_LISTA = [
	{ value: 'conference', label: 'Conference' },
	{ value: 'non_conference', label: 'Non-Conference' },
	{ value: 'playoff', label: 'Playoff Game' },
];

const MODALIDADES_LISTA = [
	{ value: 'curling', label: 'Curling' },
	{ value: 'hoquei_no_gelo', label: 'Hóquei no gelo' }
];

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);
	const permissions = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);
	const [, setRefresh] = useState(0)

	const [show_delete_button, set_show_delete_button] = useState(false);
	const [is_edit, set_is_edit] = useState(false);

	const [temporadas_lista, set_temporadas_lista] = useState([]);
	const [clubes_lista, set_clubes_lista] = useState([]);
	const [atletas_lista, set_atletas_lista] = useState([]);
	const [convocatorias, set_convocatorias] = useState([]);
	const [competicoes, set_competicoes] = useState([]);
	const [equipas_disponiveis_props, set_equipas_disponiveis_props] = useState([]);

	const [uid,] = useState(uniqid());

	const fetch_clubes = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Clube`)
			if (res.data !== undefined) {
				set_clubes_lista(res.data)
			}
			console.log('Lista de clubes carregada com sucesso:', res.data)
		} catch (error) {
			console.error('Erro ao carregar lista de clubes:', error)
		}
	}

	const fetch_atletas = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/special/${getTokenInfo().companycode}/*`)
			if (res.data !== undefined) {
				// set_atletas_lista(res.data)
			}
			console.log('Lista de atletas carregada com sucesso:', res.data)
		} catch (error) {
			console.error('Erro ao carregar lista de atletas:', error)
		}
	}

	const fetch_competicoes = async () => {
		try {
			const res = await reqGET(`${api_crud_base}/intranet/components/type/${getTokenInfo().companycode}/competicoes`)

			if (res.data !== undefined) {
				set_competicoes(res.data)
			}
		} catch (error) {
			console.error('Erro ao carregar lista de competições:', error)
		}
	}

	const fetch_convocatorias = async () => {
		try {
			const res = await reqGET(`${api_crud_base}/intranet/components/type/${getTokenInfo().companycode}/convocatorias`)

			if (res.data !== undefined) {
				set_convocatorias(res.data)
			}
		} catch (error) {
			console.error('Erro ao carregar lista de convocatórias:', error)
		}
	}

	const fetch_temporadas = async () => {
		let res = await reqGET(`${api_crud_base}/intranet/components/type/${getTokenInfo().companycode}/temporada`)
		let result = []

		if (res.data !== undefined) {
			for await (let el of res.data) {
				if (!el.info.avaiable) continue

				result.push({
					id: el.id,
					name: translate(el.info.title, 'pt')
				})
			}
		}

		return result
	}

	const order_array_desc = (array) => {
		return array.sort((a, b) => {
			return b.name.localeCompare(a.name, undefined, { numeric: true, sensitivity: 'base' })
		});
	}

	useEffect(() => {
		fetch_clubes()
		fetch_atletas()
		fetch_convocatorias()
		fetch_competicoes()
	}, [])

	const ensure_defaults = (d) => {
		const info_defaults = {
			temporada: '',
			modalidade: '',
			pista: '',
			hora_inicio: '',
			data_jogo: '',
			tipo_jogo: '',

			equipa_casa: null,
			treinador_casa: null,
			jogadores_casa: [],

			equipa_visitante: null,
			treinador_visitante: null,
			jogadores_visitante: [],
		}

		d.info = { ...info_defaults, ...d.info }
		Object.keys(info_defaults).forEach(k => {
			if (d.info[k] === null || d.info[k] === undefined) {
				d.info[k] = info_defaults[k]
			}
		})

		return d
	}

	const clean_data = () => {
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current = ensure_defaults(dados.current))
	}

	const fetch_id_info = async (id_serch) => {

		let aux_equipas = []
		let res_e = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/Clube`)
		if(Array.isArray(res_e?.data) && res_e.data.length > 0) {
			for await (let e of res_e.data) {
				aux_equipas.push({
					value: e.id,
					label: e.name
				})
			}
		}
		set_equipas_disponiveis_props(aux_equipas)

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = ensure_defaults(res.data[0]));
			})
			.catch(error => console.log(error))
	}

	let get_permissions = async (e, sidebar) => {
		let handleSingleCheck = async (e, sidebar) => {
			const name = e;

			let ver_submenu = async (node) => {
				if (node.submenu.length !== 0) {
					for await (let subitem of node.submenu) {
						if (subitem.path === name) {
							let aux = {}
							if (permissions.current !== null) {
								aux = permissions.current
								if (aux.create === false) aux.create = subitem.create
								if (aux.edit === false) aux.edit = subitem.edit
								if (aux.remove === false) aux.remove = subitem.remove
							} else {
								aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
							}
							permissions.current = aux
						} else {
							await ver_submenu(subitem)
						}
					}
				}
			}

			for await (let node of sidebar) {
				if (node.path === name) {
					let aux = {}
					if (permissions.current !== null) {
						aux = permissions.current
						if (aux.create === false) aux.create = node.create
						if (aux.edit === false) aux.edit = node.edit
						if (aux.remove === false) aux.remove = node.remove
					} else {
						aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
					}
					permissions.current = aux
				} else {
					await ver_submenu(node)
				}
			}
		}

		await handleSingleCheck(e, sidebar)
	}

	const item_id = props?.location?.state?.item?.id
	const operation = props?.location?.state?.operation

	useEffect(() => {
		clean_data();
		set_lang(localStorage.getItem('lang'))
		set_temporadas_lista([])
		setRedirect(false);

		const get_attr = async () => {
			let res_1 = await fetch_temporadas()

			if (res_1.length > 0) {
				res_1 = order_array_desc(res_1)

				let res_aux_1 = res_1.map(el => ({
					id: el.id,
					label: el.name,
				}))

				set_temporadas_lista(res_aux_1)

				if (operation !== 'edit') {
					set_dados(dados.current.info.temporada = res_aux_1[0]?.label ?? '')
				}
			}
		}

		const fetch_permissions = async () => {
			await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(endpoints.list, v) })

			if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {
				for await (let el of getTokenInfo().entity_profile) {
					await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(endpoints.list, v) })
				}
			}
		}

		if (operation === 'edit' && item_id) {
			set_is_edit(true)
			set_show_delete_button(true)

			Promise.all([fetch_id_info(item_id), get_attr(), fetch_permissions()]).then(() => {
				setLoading(false)
			})
			return
		}
		else {
			console.log('props.location.state', props.location.state)

			if(props?.location?.state?.item_go_back !== undefined) {
				console.log('props.location.state.item_go_back', props.location.state.item_go_back)
				console.log('props.location.state.equipas', props.location.state.equipas)

				set_dados(dados.current.info.competition = props.location.state.item_go_back.id)

				set_atletas_lista(props.location.state.item_go_back.info.atletas_inscritos)

			}

			// if(Array.isArray(props?.location?.state?.equipas)) {
			// 	let aux_equipas = []
			// 	props.location.state.equipas.forEach(e => {
			// 		aux_equipas.push({
			// 			value: e.id,
			// 			label: e.name
			// 		})
			// 	})
			// 	set_equipas_disponiveis_props(aux_equipas)
			// }
			// else {
				let aux_equipas = []
			
				let res_e = reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/Clube`)
				if(Array.isArray(res_e?.data) && res_e.data.length > 0) {
					res_e.data.forEach(e => {
						aux_equipas.push({
							value: e.id,
							label: e.name
						})
					})
				}
				set_equipas_disponiveis_props(aux_equipas)
			// }

		}

		Promise.all([get_attr(), fetch_permissions()]).then(() => {
			setLoading(false)
		})

	}, [item_id, operation])

	const temporada_form = dados.current?.info?.temporada || ''
	const modalidade_form = dados.current?.info?.modalidade || ''

	const normalizar_epoca = (valor) => {
		if (!valor) return ''
		const partes = String(valor).split('/').map(p => p.trim())
		if (partes.length !== 2) return String(valor).trim()

		const [inicio, fim] = partes
		if (fim.length === 4) return `${inicio}/${fim}`
		if (fim.length === 2 && inicio.length === 4) return `${inicio}/${inicio.slice(0, 2)}${fim}`
		return `${inicio}/${fim}`
	}

	const convocatorias_da_temporada = convocatorias.filter(c => normalizar_epoca(c?.info?.epoca) === normalizar_epoca(temporada_form))

	const normalizar_lista_por_epoca = (valor, epoca) => {
		if (Array.isArray(valor)) return valor
		if (valor && typeof valor === 'object') return valor[epoca] || []
		return []
	}

	const get_equipas_disponiveis = () => {
		const mapa = new Map()
		convocatorias_da_temporada.forEach(c => {
			const clubes = normalizar_lista_por_epoca(c?.info?.clubes_inscritos, c?.info?.epoca)
			clubes.forEach(cl => {
				if (!mapa.has(String(cl.id))) mapa.set(String(cl.id), { value: cl.id, label: cl.label })
			})
		})
		return Array.from(mapa.values()).sort((a, b) => a.label.localeCompare(b.label))
	}

	const clube_ids = new Set(clubes_lista.map(c => String(c.id)))

	const get_modalidades_entidade = (entidade) => {
		const mods = entidade?.info?.modalidades ?? entidade?.modalidades
		return Array.isArray(mods) ? mods.map(m => (m?.value ?? m)) : []
	}

	const get_jogadores_disponiveis = (clube_id) => {
		if (!clube_id || !modalidade_form) return []


		console.log('atletas_lista', atletas_lista)
		console.log('clube_id', clube_id)

		return atletas_lista
			.filter(e => (parseInt(e.clube_id) === parseInt(clube_id) && parseInt(e.paid) === 1))
			.map(e => ({
				id: e.id,
				label: e?.label ?? e?.label ?? '',
				numero_atleta: e?.info?.numero_atleta ?? e?.numero_atleta ?? '',
			}))
			.sort((a, b) => (Number(a.numero_atleta) || 0) - (Number(b.numero_atleta) || 0))
	}

	const get_treinadores_disponiveis = () => {
		const mapa = new Map()
		convocatorias_da_temporada.forEach(c => {
			const treinadores = normalizar_lista_por_epoca(c?.info?.treinadores_inscritos, c?.info?.epoca)
			treinadores.forEach(t => {
				if (!mapa.has(String(t.id))) mapa.set(String(t.id), t)
			})
		})
		return Array.from(mapa.values()).sort((a, b) => (a.label || '').localeCompare(b.label || ''))
	}

	const equipas_disponiveis = get_equipas_disponiveis()
	const treinadores_disponiveis = get_treinadores_disponiveis()

	const handle_change_info = (e) => {
		const { name, value } = e.target;
		set_dados(dados.current.info[name] = value)

		console.log('dados.current', dados.current)

	}

	const handle_change_info_translate = (e) => {
		const { name, value, dataset } = e.target;
		const { lang } = dataset

		console.log('dados.current.info[name]', dados.current.info[name])

		if(!Array.isArray( dados.current.info[name])) {
			console.log('1111')
			dados.current.info[name] = []
		}

		// dados.current.info[name] = []
		let value_aux = {}
		let aux = dados.current.info[name].filter(e => e[lang] !== undefined && e[lang] !== null)
		if(aux !== undefined && aux.length === 0) {
			value_aux[lang] = value
			dados.current.info[name].push(value_aux)
		}
		else {
			dados.current.info[name].forEach(el => {
				if(el[lang] !== undefined) {
					el[lang] = value
				}
			})
		}
		
		setRefresh(r => r + 1)
		

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:', dados.current.info.name)
	}

	const change_competition = (selected) => {
		console.log(selected)
		set_dados(dados.current.info.competition = selected ? selected.value : '')
	}

	const change_temporada = (selected) => {
		set_dados(dados.current.info.temporada = selected ? selected.value : '')
		set_dados(dados.current.info.equipa_casa = null)
		set_dados(dados.current.info.equipa_visitante = null)
		set_dados(dados.current.info.jogadores_casa = [])
		set_dados(dados.current.info.jogadores_visitante = [])
	}

	const change_tipo_jogo = (selected) => {
		set_dados(dados.current.info.tipo_jogo = selected ? selected.value : '')
	}

	const change_modalidade = (selected) => {
		set_dados(dados.current.info.modalidade = selected ? selected.value : '')
		set_dados(dados.current.info.jogadores_casa = [])
		set_dados(dados.current.info.jogadores_visitante = [])
	}

	const change_equipa = (lado, selected) => {
		const campo_equipa = lado === 'casa' ? 'equipa_casa' : 'equipa_visitante'
		const campo_jogadores = lado === 'casa' ? 'jogadores_casa' : 'jogadores_visitante'
		set_dados(dados.current.info[campo_equipa] = selected ? { id: selected.value, label: selected.label } : null)
		set_dados(dados.current.info[campo_jogadores] = [])
	}

	const change_equipa_ = (lado, selected) => {
		const campo_equipa = lado === 'casa' ? 'equipa_casa' : 'equipa_visitante'
		set_dados(dados.current.info[campo_equipa + '_'] = selected ? { id: selected.value, label: selected.label } : null)
	}

	const adicionar_jogador = (lado, jogador) => {
		if (!jogador) return
		const campo = lado === 'casa' ? 'jogadores_casa' : 'jogadores_visitante'
		const atual = dados.current.info[campo] || []
		if (atual.some(j => String(j.id) === String(jogador.id))) return

		set_dados(dados.current.info[campo] = [
			...atual,
			{ id: jogador.id, numero: jogador.numero_atleta ?? '', nome: jogador.label ?? jogador.name ?? '' }
		])
	}

	const remover_jogador = (lado, id) => {
		const campo = lado === 'casa' ? 'jogadores_casa' : 'jogadores_visitante'
		const atual = dados.current.info[campo] || []
		set_dados(dados.current.info[campo] = atual.filter(j => String(j.id) !== String(id)))
	}

	const editar_numero_jogador = (lado, id, numero) => {
		const campo = lado === 'casa' ? 'jogadores_casa' : 'jogadores_visitante'
		const atual = dados.current.info[campo] || []
		set_dados(dados.current.info[campo] = atual.map(j => String(j.id) === String(id) ? { ...j, numero } : j))
	}

	const handleSubmit = async (e) => {
		e.preventDefault();

		Swal.fire({
			title: is_edit ? (language[lang].edit_title ?? 'Editar') : (language[lang].insert_title ?? 'Inserir'),
			text: is_edit ? (language[lang].edit_text ?? 'Confirma a edição?') : (language[lang].insert_text ?? 'Confirma a inserção?'),
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: is_edit ? (language[lang].edit_confirm ?? 'Confirmar') : (language[lang].insert_confirm ?? 'Confirmar'),
			cancelButtonText: is_edit ? (language[lang].edit_cancel ?? 'Cancelar') : (language[lang].insert_cancel ?? 'Cancelar')
		}).then((result) => {
			if (result.isConfirmed) {
				const requestMethod = is_edit ? reqPUT : reqPOST

				if(!is_edit) {
					dados.current.info['uniqid'] = uid
				}
				else {
					if (dados.current.info.uniqid !== undefined) {
						delete dados.current.info.uniqid;
					}
				}

				requestMethod(`${api_crud_route}`, dados.current)
					.then(async () => {
						// props.history.push(endpoints.list)

						if(!is_edit) {
							let res = await reqGET(`${api_crud_base}/intranet/components/uniqid/${getTokenInfo().companycode}/${uid}`)
							set_dados(dados.current.id = res.data[0].id)
						}

						Swal.fire('', language[lang].edit_success, 'info')

					})
					.catch((error) => {
					
						console.log('error', error)

						Swal.fire('', (is_edit ? (language[lang].edit_error ?? 'Erro ao editar') : (language[lang].insert_error ?? 'Erro ao inserir')), 'info')
					})
			}
		})
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title ?? 'Eliminar',
			text: language[lang].delete_text ?? 'Confirma a eliminação?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm ?? 'Eliminar',
			cancelButtonText: language[lang].delete_cancel ?? 'Cancelar'
		}).then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(() => { props.history.push(endpoints.list); })
					.catch(() => Swal.fire(language[lang].delete_error ?? 'Erro ao eliminar', '', 'info'))
			}
		})
	};

	const handleSingleCheckActive = () => {
		set_dados(dados.current.info.active = !dados.current.info.active)
	}

	const handleSingleCheckAvailable = () => {
		console.log('dados.current.info', dados.current.info)
		set_dados(dados.current.info.available = !dados.current.info.available)
	}

	const tem_permissao_acao = permissions.current !== null && (is_edit ? permissions.current.edit : permissions.current.create);
	const pode_editar = tem_permissao_acao;

	const render_equipa_bloco = (lado, titulo) => {

		console.log('lado', lado)
		console.log('titulo', titulo)
		console.log('dados.current.info', dados.current.info)

		const campo_equipa = lado === 'casa' ? 'equipa_casa' : 'equipa_visitante'
		const campo_treinador = lado === 'casa' ? 'treinador_casa' : 'treinador_visitante'
		const campo_jogadores = lado === 'casa' ? 'jogadores_casa' : 'jogadores_visitante'

		const equipa_selecionada = dados.current.info[campo_equipa]
		const equipa_selecionada_ = dados.current.info[campo_equipa + '_']
		const outra_equipa = dados.current.info[lado === 'casa' ? 'equipa_visitante' : 'equipa_casa']
		const jogadores_roster = dados.current.info[campo_jogadores] || []
		const jogadores_disponiveis = get_jogadores_disponiveis(equipa_selecionada?.id).filter(
			j => !jogadores_roster.some(r => String(r.id) === String(j.id))
		)

		return (
			<div className="col-md-6">
				<div className="border rounded h-100">
					<div className="p-2 border-bottom" style={{ backgroundColor: '#f4f4f4' }}>
						<strong>{titulo}</strong>
					</div>

					<div className="p-3">
						<div className="mb-3">
							<label className="form-label fw-bold fs-6">{titulo}</label>
							<div className='d-flex'>
								<Select
									className="div-select flex-grow-1"
									options={equipas_disponiveis_props} // {equipas_disponiveis_props.filter(e => String(e.value) !== String(outra_equipa?.id))}
									value={equipa_selecionada ? { value: equipa_selecionada.id, label: equipa_selecionada.label } : null}
									placeholder={temporada_form ? (language[lang]?.select ?? 'Selecione') : (language[lang]?.selecione_primeiro_epoca ?? 'Selecione primeiro a época')}
									onChange={(selected) => change_equipa(lado, selected)}
									isDisabled={!pode_editar || !temporada_form}
									isClearable
								/>
								{
								equipa_selecionada !== undefined && equipa_selecionada !== null &&
								equipa_selecionada?.id !== undefined && equipa_selecionada?.id !== null &&
								outra_equipa?.id !== undefined && outra_equipa?.id !== null && parseInt(equipa_selecionada.id) === parseInt(outra_equipa.id) ?
									<Select
										className="div-select flex-shrink-0 ms-1 w-25"
										options={[{id: 'a', label: 'A'}, {id: 'b', label: 'B'}, {id: 'c', label: 'C'}, {id: 'd', label: 'D'}]}
										value={equipa_selecionada_ ? { value: equipa_selecionada_.id, label: equipa_selecionada_.label } : null}
										placeholder={temporada_form ? (language[lang]?.select ?? 'Selecione') : (language[lang]?.selecione_primeiro_epoca ?? 'Selecione primeiro a época')}
										onChange={(selected) => change_equipa_(lado, selected)}
										isDisabled={!pode_editar || !temporada_form}
										isClearable
									/>
								:
									null
								}
							</div>
						</div>

						<div className="mb-3">
							<label className="form-label fw-bold fs-6">{language[lang]?.treinador ?? 'TREINADOR'}</label>
							<Select
								className="div-select"
								options={treinadores_disponiveis.map(t => ({ value: t.id, label: t.label }))}
								value={dados.current.info[campo_treinador] ? { value: dados.current.info[campo_treinador].id, label: dados.current.info[campo_treinador].label } : null}
								placeholder={temporada_form ? (language[lang]?.selecionar_treinador ?? 'Selecione o treinador') : (language[lang]?.selecione_primeiro_epoca ?? 'Selecione primeiro a época')}
								onChange={(selected) => set_dados(dados.current.info[campo_treinador] = selected ? { id: selected.value, label: selected.label } : null)}
								isDisabled={!pode_editar || !temporada_form}
								isClearable
							/>
						</div>

						<div className="mb-2">
							<label className="form-label fw-bold fs-6">{language[lang]?.adicionar_jogador ?? 'Adicionar jogador'}</label>
							<Select
								className="div-select"
								options={jogadores_disponiveis.map(j => ({
									value: j.id,
									label: `${j.numero_atleta ? j.numero_atleta + ' — ' : ''}${j.label}`,
								}))}
								value={null}
								placeholder={
									!modalidade_form
										? (language[lang]?.selecione_primeiro_modalidade ?? 'Selecione primeiro a modalidade')
										: equipa_selecionada
											? (language[lang]?.escolher_jogador ?? 'Escolher jogador...')
											: (language[lang]?.selecione_primeiro_equipa ?? 'Selecione primeiro a equipa')
								}
								onChange={(selected) => {
									const jogador = get_jogadores_disponiveis(equipa_selecionada?.id).find(j => String(j.id) === String(selected?.value))
									adicionar_jogador(lado, jogador)
								}}
								isDisabled={!pode_editar || !equipa_selecionada || !modalidade_form}
							/>
						</div>

						<table className="table table-bordered align-middle mb-0">
							<thead>
								<tr style={{ backgroundColor: '#d9d9d9' }}>
									<th style={{ width: '70px' }}>{language[lang]?.numero ?? 'N.º'}</th>
									<th>{language[lang]?.nome_jogadores ?? 'JOGADOR'}</th>
									<th style={{ width: '40px' }}></th>
								</tr>
							</thead>
							<tbody>
								{jogadores_roster.length > 0 ? (
									jogadores_roster.map((j) => (
										<tr key={j.id}>
											<td>
												<input
													type="text"
													className="form-control form-control-sm rounded-0 text-end"
													value={j.numero}
													onChange={(e) => editar_numero_jogador(lado, j.id, e.target.value)}
													disabled={!pode_editar}
												/>
											</td>
											<td>{j.nome}</td>
											<td className="text-end">
												<button
													type="button"
													className="btn btn-sm btn-danger rounded-0"
													onClick={() => remover_jogador(lado, j.id)}
													disabled={!pode_editar}
												>
													<i className="bi bi-x-lg"></i>
												</button>
											</td>
										</tr>
									))
								) : (
									<tr>
										<td colSpan="3" className="text-center text-muted">Sem jogadores</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		)
	}

	return isloading ?

		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">
						{language[lang]?.ficha_jogo ?? 'Ficha de Jogo'}{modalidade_form ? ` de ${MODALIDADES_LISTA.find(m => m.value === modalidade_form)?.label ?? ''}` : ''}{temporada_form ? ` - ${language[lang]?.temporada_label ?? 'Temporada'} ${temporada_form}` : ''}
					</h2>
					<p>Jogos / {dados.current.id !== '' ? (language[lang].entity_edit ?? 'Editar') : (language[lang].entity_new ?? 'Novo')}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">

								<div className="card">
									<div className="collapse show">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">
												<fieldset disabled={!pode_editar} style={{ border: 'none', padding: 0, margin: 0 }}>

													<div className="row g-3 mb-3">

														<div className="col-8 col-md-8">
															<label className="form-label fw-bold fs-6">{language[lang]?.name ?? 'Nome'}</label>
															<input type="text" name="name" data-langid={'1'} data-lang={'pt'} value={translate(dados.current.info.name, 'pt')} className="form-control rounded-0" onChange={handle_change_info_translate} />
														</div>

														<div className="col-4 col-md-4"> 
															<div className="d-flex">
																<div className="mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].field_available}</label>
																	<div className="input-group">
																		<label className="switch">
																			<input
																				id={'item-switch-available'}
																				name={"available"}
																				className=""
																				type="checkbox"
																				value={dados.current.info.available}
																				onChange={handleSingleCheckAvailable}
																				defaultChecked={dados.current.info.available}
																			/>
																			<span className="slider" htmlFor={'item-switch-available'}></span>
																		</label>
																	</div>
																</div>
																<div className="ms-3 mb-3">
																	<label className="fs-6 fw-bold mb-2">{language[lang].field_activo}</label>
																	<div className="input-group">
																		<label className="switch">
																			<input
																				id={'item-switch-active'}
																				name={"active"}
																				className=""
																				type="checkbox"
																				value={dados.current.info.active}
																				onChange={handleSingleCheckActive}
																				defaultChecked={dados.current.info.active}
																			/>
																			<span className="slider" htmlFor={'item-switch-active'}></span>
																		</label>
																	</div>
																</div>
																
															</div>
														</div>

														<div className="col-6 col-md-4">
															<label className="form-label fw-bold fs-6">{language[lang]?.competition ?? 'Competição'}</label>
															<Select
																className="div-select"
																options={competicoes.map(c => ({ value: c.id, label: c.info.name }))}
																value={dados.current.info.competition ? { value: dados.current.info.competition, label: competicoes.find(e => parseInt(e.id) === parseInt(dados.current.info.competition))?.info?.name } : null}
																placeholder={language[lang].select ?? 'Selecione'}
																onChange={change_competition}
															/>
														</div>
														<div className="col-6 col-md-4">
															<label className="form-label fw-bold fs-6">{language[lang]?.pista ?? 'PISTA'}</label>
															<input type="text" name="pista" value={dados.current.info.pista} className="form-control rounded-0" onChange={handle_change_info} />
														</div>
														<div className="col-4 col-md-2">
															<label className="form-label fw-bold fs-6">{language[lang]?.data_jogo ?? 'Data'}</label>
															<input type="date" name="data_jogo" value={dados.current.info.data_jogo} className="form-control rounded-0" onChange={handle_change_info} />
														</div>
														<div className="col-4 col-md-2">
															<label className="form-label fw-bold fs-6">{language[lang]?.hora_inicio ?? 'Hora Início'}</label>
															<input type="time" name="hora_inicio" value={dados.current.info.hora_inicio} className="form-control rounded-0" onChange={handle_change_info} />
														</div>
													</div>

													<div className="row g-3 mb-4">
														<div className="col-md-4">
															<label className="form-label fw-bold fs-6">Época</label>
															<Select
																className="div-select"
																options={temporadas_lista.map(t => ({ value: t.label, label: t.label }))}
																value={temporada_form ? { value: temporada_form, label: temporada_form } : null}
																placeholder={language[lang].select ?? 'Selecione'}
																onChange={change_temporada}
																isDisabled={!pode_editar}
															/>
														</div>
														<div className="col-md-4">
															<label className="form-label fw-bold fs-6">Modalidade</label>
															<Select
																className="div-select"
																options={MODALIDADES_LISTA}
																value={MODALIDADES_LISTA.find(m => m.value === modalidade_form) ?? null}
																placeholder={language[lang].select ?? 'Selecione'}
																onChange={change_modalidade}
																isDisabled={!pode_editar}
															/>
														</div>
														<div className="col-md-4">
															<label className="form-label fw-bold fs-6">{language[lang]?.tipo_jogo ?? 'Tipo de Jogo'}</label>
															<Select
																className="div-select"
																options={TIPO_JOGO_LISTA}
																value={TIPO_JOGO_LISTA.find(o => o.value === dados.current.info.tipo_jogo) ?? null}
																placeholder={language[lang].select ?? 'Selecione'}
																onChange={change_tipo_jogo}
																isDisabled={!pode_editar}
															/>
														</div>
													</div>

													<div className="row g-3">
														{render_equipa_bloco('casa', language[lang]?.eq_casa ?? 'EQ. DA CASA')}
														{render_equipa_bloco('visitante', language[lang]?.eq_visitante ?? 'EQ. VISITANTE')}
													</div>

												</fieldset>
											</div>
										</form>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel d-none" to={{ pathname: endpoints.list }}>
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back ?? 'Voltar'}</span>
									</Link>

									<Link className="nav-link btn-cancel" to={{ pathname: (props.location.state !== null && props.location.state.go_back_operation === 'intranet_competicoes_regist' ? Intranet_Competicoes.regist.endpoint : endpoints.list), state: { item: (props.location.state !== null && props.location.state.item_go_back !== undefined ? props.location.state.item_go_back : null), operation: 'edit', tab: 'games' } } }  >
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back}</span>
									</Link>

								</li>
								<li className={"nav-item " + (show_delete_button && permissions.current?.remove ? '' : 'd-none')}>
									<button type="button" onClick={() => apagar()} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete ?? 'Eliminar'}</span>
									</button>
								</li>
								{pode_editar && (
									<li className="nav-item d-none">
										<Link className="nav-link" to={{ state: { item: { id: dados.current.id }, operation: 'view' }, pathname: endpoints.view }} replace>
											<i className="bi bi-eye me-2"></i>
											<span>{language[lang]?.sheet ?? 'Ficha'}</span>
										</Link>
									</li>
								)}
								{pode_editar && (
									<li className="nav-item">
										<button type="submit" form="form" className="nav-link">
											<i className="bi bi-floppy me-2"></i>
											<span>{language[lang].save ?? 'Gravar'}</span>
										</button>
									</li>
								)}
							</ul>
						</div>
					</nav>
				</div>
			</main>
}